"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _header = _interopRequireDefault(require("./mobile/header"));
var _header2 = _interopRequireDefault(require("./desktop/header"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CabecalhoSuperior = function CabecalhoSuperior(props) {
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: 841
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile ? /*#__PURE__*/_react["default"].createElement(_header["default"], props) : /*#__PURE__*/_react["default"].createElement(_header2["default"], props));
};
var _default = CabecalhoSuperior;
exports["default"] = _default;